// Find icon names here: https://fonts.google.com/icons

import { Text, TextProps } from "@chakra-ui/react";

export interface IMaterialIconProps extends TextProps {
  variant?: "outline" | "filled";
  name:
    | "dark_mode"
    | "light_mode"
    | "menu"
    | "enhanced_encryption"
    | "done"
    | "check"
    | "play_arrow"
    | "alternate_email"
    | "toggle_on"
    | "fingerprint"
    | "transform"
    | "dataset"
    | "error"
    | "water"
    | "waves"
    | "123"
    | "edit"
    | "description"
    | "text_fields"
    | "badge"
    | "notifications"
    | "label"
    | "database"
    | "account_circle"
    | "menu_open"
    | "self_improvement"
    | "calculate"
    | "checklist"
    | "radio_button_checked"
    | "join_inner"
    | "support"
    | "arrow_upward"
    | "arrow_downward"
    | "view_column"
    | "group_work"
    | "history"
    | "query_stats"
    | "link"
    | "add"
    | "undo"
    | "redo"
    | "key"
    | "email"
    | "backspace"
    | "save"
    | "cancel"
    | "waterfall_chart"
    | "date_range"
    | "arrow_back"
    | "arrow_right_alt"
    | "auto_graph"
    | "filter_alt"
    | "group_add"
    | "keyboard_tab"
    | "close"
    | "file_download"
    | "fullscreen"
    | "filter_alt_off"
    | "push_pin"
    | "groups"
    | "login"
    | "logout"
    | "list"
    | "view_list"
    | "mode_edit"
    | "workspaces"
    | "visibility_off"
    | "info"
    | "search"
    | "more_horiz"
    | "manage_search"
    | "analytics"
    | "apps"
    | "person"
    | "person_remove"
    | "sort"
    | "flag"
    | "delete"
    | "star"
    | "biotech"
    | "category"
    | "star_outline"
    | "store"
    | "local_library"
    | "question_mark"
    | "start"
    | "content_copy"
    | "filter"
    | "filter_alt"
    | "refresh"
    | "filter_list"
    | "lock"
    | "ads_click"
    | "sentiment_neutral"
    | "diversity_1"
    | "diversity_2"
    | "travel_explore"
    | "disabled_visible"
    | "share"
    | "show_chart"
    | "cloud_upload"
    | "description"
    | "upload_file"
    | "data_exploration"
    | "table"
    | "task"
    | "attach_file_add"
    | "settings"
    | "sync"
    | "shuffle"
    | "swap_horizontal_circle"
    | "partner_exchange"
    | "compare_arrows";
}

export const MaterialIcon = (props: IMaterialIconProps) => {
  const { name, variant = "filled", ...rest } = props;
  return (
    <Text
      display={"block"}
      className={
        variant === "outline" ? "material-icons-outlined" : "material-icons"
      }
      {...rest}
    >
      {name}
    </Text>
  );
};
